import SessionContainer from '~/components/session-container/session-container';

export default function Session() {
  return (
      <div className="h-screen w-full">
        <SessionContainer />
      </div>
  );
}
